import { socket } from "../index";
import { Message } from "../type";

const emitSendMessage = (
  roomId: string,
  message: Message
) => {
  socket?.emit('SEND_MESSAGE', { 
    roomId,
    message,
  });
}

export default emitSendMessage;